/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostRegisterFirstClipBody
 */
export interface PostRegisterFirstClipBody {
    /**
     * 企業ID
     * @type {number}
     * @memberof PostRegisterFirstClipBody
     */
    companyId: number;
    /**
     * クリップID
     * @type {number}
     * @memberof PostRegisterFirstClipBody
     */
    clipId: number;
}

export function PostRegisterFirstClipBodyFromJSON(json: any): PostRegisterFirstClipBody {
    return PostRegisterFirstClipBodyFromJSONTyped(json, false);
}

export function PostRegisterFirstClipBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostRegisterFirstClipBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'clipId': json['clip_id'],
    };
}

export function PostRegisterFirstClipBodyToJSON(value?: PostRegisterFirstClipBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_id': value.companyId,
        'clip_id': value.clipId,
    };
}

